import { TEMPLATES } from "@/lib/wedding";
import { EDITOR } from "@/constants/testIds";
import { Check } from "lucide-react";

export default function TemplatePicker({ value, onChange }) {
    return (
        <div className="grid grid-cols-2 gap-3">
            {TEMPLATES.map((tpl) => {
                const active = value === tpl.id;
                const testId =
                    tpl.id === "classic-elegant"
                        ? EDITOR.templateClassic
                        : EDITOR.templateMinimal;
                return (
                    <button
                        key={tpl.id}
                        type="button"
                        data-testid={testId}
                        onClick={() => onChange(tpl.id)}
                        className={`relative text-left rounded-2xl border p-3 transition-all duration-200 ${
                            active
                                ? "border-[var(--ink)] shadow-[0_8px_24px_rgba(20,16,12,0.08)]"
                                : "border-[var(--line)] hover:border-[var(--gold-soft)]"
                        }`}
                        style={{ background: "#fff" }}
                    >
                        <div className="flex items-center gap-1.5 mb-3">
                            {tpl.swatch.map((c) => (
                                <span
                                    key={c}
                                    className="inline-block w-4 h-4 rounded-full border"
                                    style={{
                                        background: c,
                                        borderColor:
                                            "rgba(20,16,12,0.08)",
                                    }}
                                />
                            ))}
                        </div>
                        <div className="font-serif text-lg leading-tight">
                            {tpl.name}
                        </div>
                        <div className="text-xs text-[var(--ink-soft)] mt-1">
                            {tpl.description}
                        </div>
                        {active && (
                            <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-[var(--ink)] text-white flex items-center justify-center">
                                <Check size={14} />
                            </div>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
